import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { logout as logoutAction } from "../store/authSlice";
import { authService } from "../api/services/auth.service";

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const logout = async () => {
    try {
      // Call backend to clear httpOnly cookies
      await authService.logout();

      // Clear all React Query cache to prevent stale data from previous user
      queryClient.clear();

      // Clear Redux state
      dispatch(logoutAction());

      // Navigate to signin page
      navigate("/signin");
    } catch (error) {
      console.error("Logout failed:", error);

      // Even if backend call fails, clear local state and navigate
      queryClient.clear();
      dispatch(logoutAction());
      navigate("/signin");
    }
  };

  return { logout };
};
